import React__default from 'react';
import { B2BGoogleOneTap } from './components/B2BOneTap.mjs';
import { emailIcons, oauthIcons, ssoIcons } from './components/Icons.mjs';
import { OAuthB2BButton } from './components/OAuthB2BButton.mjs';
import { SSOButton } from './components/SSOButton.mjs';
import { EmailConfirmation } from './screens/EmailConfirmation.mjs';
import { EmailDiscoveryForm, EmailForm } from './screens/EmailForm.mjs';
import { EmailMethodSelectionScreen } from './screens/EmailMethodSelectionScreen.mjs';
import { EmailOTPEntryScreen } from './screens/EmailOTPEntryScreen.mjs';
import { PasswordsAuthenticate } from './screens/PasswordAuthenticate.mjs';
import { PasswordsEmailForm } from './screens/PasswordEmailForm.mjs';
import { PasswordsForgotForm } from './screens/PasswordForgotForm.mjs';
import { PasswordResetConfirmation } from './screens/PasswordResetConfirmation.mjs';
import { PasswordResetForm } from './screens/PasswordResetForm.mjs';
import { PasswordSetNew } from './screens/PasswordSetNew.mjs';
import { SsoAndOAuthButtons } from './screens/SsoAndOAuthButtons.mjs';
import { SSODiscoveryEmail } from './screens/SSODiscoveryEmail.mjs';
import { SSODiscoveryFallback } from './screens/SSODiscoveryFallback.mjs';
import { SSODiscoveryMenu } from './screens/SSODiscoveryMenu.mjs';
import { MainScreenComponent, AppScreens } from './types/AppScreens.mjs';

const EmailFormWithoutPassword = ()=>/*#__PURE__*/ React__default.createElement(EmailForm, {
        showPasswordButton: false
    });
const EmailFormWithPassword = ()=>/*#__PURE__*/ React__default.createElement(EmailForm, {
        showPasswordButton: true
    });
const EmailDiscoveryFormWithoutPassword = ()=>/*#__PURE__*/ React__default.createElement(EmailDiscoveryForm, {
        showPasswordButton: false
    });
const EmailDiscoveryFormWithPassword = ()=>/*#__PURE__*/ React__default.createElement(EmailDiscoveryForm, {
        showPasswordButton: true
    });
const emailMagicLinks = {
    id: 'emailMagicLinks',
    screens: {
        [AppScreens.EmailConfirmation]: EmailConfirmation,
        [AppScreens.EmailMethodSelection]: EmailMethodSelectionScreen
    },
    mainScreen: {
        [MainScreenComponent.EmailForm]: EmailFormWithoutPassword,
        [MainScreenComponent.EmailDiscoveryForm]: EmailDiscoveryFormWithoutPassword,
        [MainScreenComponent.PasswordEmailCombined]: EmailFormWithPassword,
        [MainScreenComponent.PasswordEmailCombinedDiscovery]: EmailDiscoveryFormWithPassword
    },
    icons: emailIcons
};
const emailOtp = {
    id: 'emailOtp',
    screens: {
        [AppScreens.EmailOTPEntry]: EmailOTPEntryScreen,
        [AppScreens.EmailMethodSelection]: EmailMethodSelectionScreen,
        [AppScreens.EmailConfirmation]: EmailConfirmation
    },
    mainScreen: {
        [MainScreenComponent.EmailForm]: EmailFormWithoutPassword,
        [MainScreenComponent.EmailDiscoveryForm]: EmailDiscoveryFormWithoutPassword,
        [MainScreenComponent.PasswordEmailCombined]: EmailFormWithPassword,
        [MainScreenComponent.PasswordEmailCombinedDiscovery]: EmailDiscoveryFormWithPassword
    },
    icons: emailIcons
};
const sso = {
    id: 'sso',
    screens: {
        [AppScreens.SSODiscoveryEmail]: SSODiscoveryEmail,
        [AppScreens.SSODiscoveryMenu]: SSODiscoveryMenu,
        [AppScreens.SSODiscoveryFallback]: SSODiscoveryFallback
    },
    ssoAndOAuthButtons: {
        SsoAndOAuthButtons,
        SSOButton
    },
    icons: ssoIcons
};
const passwords = {
    id: 'passwords',
    screens: {
        [AppScreens.PasswordEmailForm]: PasswordsEmailForm,
        [AppScreens.PasswordAuthenticate]: PasswordsAuthenticate,
        [AppScreens.PasswordForgotForm]: PasswordsForgotForm,
        [AppScreens.PasswordSetNewConfirmation]: PasswordSetNew,
        [AppScreens.PasswordResetForm]: PasswordResetForm,
        [AppScreens.PasswordResetVerifyConfirmation]: PasswordResetConfirmation
    },
    mainScreen: {
        [MainScreenComponent.PasswordsEmailForm]: PasswordsEmailForm,
        [MainScreenComponent.PasswordEmailCombined]: EmailFormWithPassword,
        [MainScreenComponent.PasswordEmailCombinedDiscovery]: EmailDiscoveryFormWithPassword
    },
    icons: emailIcons
};
const oauth = {
    id: 'oauth',
    screens: {},
    ssoAndOAuthButtons: {
        SsoAndOAuthButtons,
        B2BGoogleOneTap,
        OAuthB2BButton
    },
    icons: oauthIcons
};

export { emailMagicLinks, emailOtp, oauth, passwords, sso };
//# sourceMappingURL=B2BProducts.mjs.map
